// meetingRooms/hooks/useMeetingRoomState.js
import { useState, useEffect } from 'react';

export const useMeetingRoomState = (allMeetingRooms) => {
  const [expandedMeetingRooms, setExpandedMeetingRooms] = useState({});
  const [showCreateDialog, setShowCreateDialog] = useState(false);
  const [isCreating, setIsCreating] = useState(false);

  // Auto-expand if only one meeting room
  useEffect(() => {
    if (allMeetingRooms.length === 1) {
      setExpandedMeetingRooms({ [allMeetingRooms[0].slug]: true });
    }
  }, [allMeetingRooms.length]);

  const handleToggleMeetingRoom = (meetingRoomSlug) => {
    setExpandedMeetingRooms(prev => {
      const newState = { ...prev };
      if (newState[meetingRoomSlug]) {
        delete newState[meetingRoomSlug];
      } else {
        newState[meetingRoomSlug] = true;
      }
      return newState;
    });
  };

  const handleCloseCreateDialog = () => setShowCreateDialog(false);

  return {
    expandedMeetingRooms,
    showCreateDialog,
    isCreating,
    setIsCreating,
    handleToggleMeetingRoom,
    handleCloseCreateDialog,
    setShowCreateDialog
  };
};